import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { useAuthHandling } from '../useAuthhandling';
import Cookies from 'js-cookie';
import Config from '../Config';
import Navbar from '../Navbar';
import Sidebar from '../Sidebar';
import { ToastContainer, toast } from "react-toastify";
import jwtDecode from "jwt-decode";


function Videocreate() {
    let navigate = useNavigate();
    const {handleUnauthorized } = useAuthHandling();
  
    const tokens = Cookies.get("a_token");
    if (!tokens) {
      navigate("/");
    }

    const [video, setVideo] = useState({
        title: "",
        type: "",
        url:"",
        creator:'',
    });
    const [videofile, setVideofile] = useState([]);
    const [thumbnail, setThumbnail] = useState([]);
    const [videoPreview, setVideoPreview] = useState(null);
    const [thumbnailPreview, setThumbnailPreview] = useState(null);
    const [formerror, setError] = useState({});
   const [loading, setLoading] = useState(false);
    let name, value;
  
    const handleInputs = (e) => {
      name = e.target.name;
      value = e.target.value;
      setVideo({ ...video, [name]: value });
    };
  
   
  
    const validate = (values) => {
      const errors = {};
      if (!values.title) {
        errors.title = "Title is required!";
      }
  
      if (!values.type) {
        errors.type = "Video type is required!";
      }
      if(values.type==='Shorts'){
        if (videofile.length===0) {
          errors.file = "Video is required!";
        }
      }
      else{
      if (!values.url) {
        errors.url = "URL is required!";
      }
      }
     
      if (!thumbnail) {
        errors.thumbnail = "Image is required!";
      } else if (thumbnail.type) {
        if (
            thumbnail.type === "image/jpeg" ||
          thumbnail.type === "image/jpg" ||
          thumbnail.type === "image/png"
        ) {
         console.log();
        } else {
          errors.customerImage = "Only support jpg, jpeg, png image!";
        }
      }
      return errors;
    };
  
    // const PostData = async (e) => {
    //   e.preventDefault();
    //   const ress = validate(video);
    //   setError(ress);
    //   let videodata={};
    //   if(type==='Video'){
    //     videodata.video=videofile
    //   }
    //   else{
    //     videodata.thumbnail=videofile

    //   }
    //   if (!ress.title && !ress.type && !ress.url && !ress.file) {
    //     const res = await fetch(
    //         `${Config.apiurl}/api/v1/crm/app-video/create`,
    //         {
    //           method: "POST",
    //         body: JSON.stringify({
    //             title: video.title,
    //             videoType: video.type,
    //             url:video.video.url,
    //             creator:
    //             releaseNotesIos:video.releaseNotesIos,
    //           }),
      
    //           headers: {
    //             Authorization: `Bearer ${Cookies.get("a_token")}`,
    //             "Content-type": "application/json; charset=UTF-8",
    //           },
    //       })
    //       if (res.status === 200 ) {
    //           toast.success("Sucessfully added video", {
    //             position: "top-center",
    //             autoClose: 3000,
    //             hideProgressBar: false,
    //             closeOnClick: true,
    //             pauseOnHover: true,
    //             draggable: true,
    //             progress: undefined,
    //           });
    //           setTimeout(() => navigate("/dashboard"), 3000);
       
    //         } 
    //         else if(res.status === 401){
    //           handleUnauthorized();
    //           PostData();
    //         }
    //         else {
    //           toast.error("Something went wrong", {
    //             position: "top-center",
    //             autoClose: 3000,
    //             hideProgressBar: false,
    //             closeOnClick: true,
    //             pauseOnHover: true,
    //             draggable: true,
    //             progress: undefined,
    //           });
    //         }
          
    //   }
    // };

    const PostData = async (e) => {
        e.preventDefault();
        setLoading(true); 
        const ress = validate(video);
        setError(ress);
      
        const token = Cookies.get("a_token"); 
        let userId;
        if (token) {
            const decodedToken = jwtDecode(token); // Decode the token
             userId = decodedToken.uId; // Extract user ID (check actual key in your token)
          
          }
        if (!ress.title && !ress.type && !ress.url && !ress.file && !ress.thumbnail) {
          const formData = new FormData();
          formData.append("title", video.title);
          formData.append("videoType", video.type);
          formData.append("creator", userId);
         
          formData.append("thumbnail", thumbnail);  
          if(video.type==='Shorts'){
          formData.append("video", videofile); 
          }
          else{
            formData.append("url", video.url);
          }
          
      
          try {
            const res = await fetch(`${Config.apiurl}/api/v1/crm/video/create`, {
              method: "POST",
              body: formData, // Send FormData instead of JSON
              headers: {
                Authorization: `Bearer ${Cookies.get("a_token")}`,
                // DO NOT set Content-Type manually when using FormData
              },
            });
      
            if (res.status === 200) {
              toast.success("Successfully added video", {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
              setTimeout(() => navigate("/dashboard"), 3000);
            } else if (res.status === 401) {
              handleUnauthorized();
              PostData();
            } else {
              toast.error("Something went wrong", {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            }
          } catch (error) {
            console.error("Error uploading video:", error);
          } finally {
            setLoading(false); // Hide loader when request completes
          }
        }
        else {
            setLoading(false);
          }
      };
      

    const onFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setVideofile(file);
            setVideoPreview(URL.createObjectURL(file)); // Create a video preview
          }
      };
      const onFileChangethumb = (e) => {
        const file = e.target.files[0];
        if (file) {
            setThumbnail(file);
            setThumbnailPreview(URL.createObjectURL(file)); // Create an image preview
          }
      
      };

  return (

    <>
    {loading && (
        <div className="overlay_spin ">
          <div className="spinner_spin "></div>
          <p>Uploading... Please wait</p>
        </div>
      )}
   
    <div className="container-scroller">
    <Navbar />
    <div className="container-fluid page-body-wrapper">
      <Sidebar />

     
      <div className="main-panel">
        <div className="content-wrapper">
          <div className="row">
            <div className="col-md-12 grid-margin stretch-card">
              <div className="card">
                <div className="card-body">
                  <h4 className="card-title">Youtube Videos</h4>
                  <p className="card-description">New Video</p>
                  <form className="forms-sample" onSubmit={PostData}>
                    {/* <form className="forms-sample"> */}
                    <div className="form-group">
                      <label htmlFor="exampleInputUsername1">Title</label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleInputUsername1"
                        placeholder="Title"
                        name="title"
                        value={video.title}
                        onChange={handleInputs}
                      />
                      <label style={{ color: "red" }}>
                        {formerror.title}
                      </label>
                    </div>
                   
                    <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Video Type</label>
                           <select className="form-select" name="type" value={video.type} onChange={handleInputs}>
                            <option>Select..</option>
                            <option value='Shorts'>Shorts</option>
                            <option value='Video'>Video</option>
                           </select>
                           <label style={{ color: "red" }}>{formerror.type}</label>
                          </div>
                          {video.type==="Video"?
                              <div className="form-group">
                                <label htmlFor="exampleInputUsername1">URL</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="exampleInputUsername1"
                                  placeholder="URL"
                                  name="url"
                                  value={video.url}
                                  onChange={handleInputs}
                                />
                                <label style={{ color: "red" }}>{formerror.url}</label>
                              </div>
                          :""}
                              <div className="form-group">
                                <label htmlFor="exampleInputEmail1">
                                  Video 
                                </label>
                                <br></br>
                                <input
                                  type="file"
                                  name="file"
                                  accept="video/*"
                                  onChange={onFileChange}
                                />

                                  {videoPreview && (
                                          <video  className="video_previews" width="300" controls>
                                          <source src={videoPreview} type="video/mp4" />
                                          Your browser does not support the video tag.
                                          </video>
                                      )}

                                <label style={{ color: "red" }}>
                                  {formerror.file}
                                </label>
                              </div>
                          
                
                        <div className="form-group">
                          <label htmlFor="exampleInputEmail1">
                            {video.type==="Video"?"":"Shorts "}Thumbnail 
                          </label>
                          <br></br>
                          <input
                            type="file"
                            name="thumbnail"
                           
                            onChange={onFileChangethumb}
                          />
                          <label style={{ color: "red" }}>
                            {formerror.thumbnail}
                          </label>
                          {thumbnailPreview && <img  className="video_previews"  src={thumbnailPreview} alt="Thumbnail Preview" width="150" />}
                        </div>
                
                    <button
                      type="submit"
                      onClick={PostData}
                      className="btn btn-primary me-2"
                    >
                      Submit
                    </button>
                    <ToastContainer />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
     
    </div>
  </div>
  </>
  )
}

export default Videocreate
